import React, { Fragment, useContext, useEffect } from 'react'
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';
import Cuenta from './Cuenta';
import { CSSTransition, TransitionGroup } from 'react-transition-group'

const Cuentas = () => {

    // Extraer users del context
    const barrapplContext = useContext(barraprincipalContext);
    const { cuentas, obtenerUsuarios } = barrapplContext;

    useEffect(() => {
        obtenerUsuarios();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <h2>Cuentas</h2>

            <ul className="listado-users">
                <TransitionGroup>
                    {cuentas.map(cuenta => (
                        <CSSTransition
                            key={cuenta._id}
                            timeout={200}
                            classNames="cuenta"
                        >
                            <Cuenta 
                                cuenta={cuenta}
                            />
                        </CSSTransition>
                    ))}
                </TransitionGroup>
            </ul>
        </Fragment> 
    );
}
 
export default Cuentas;